import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import Pagination from '../paginnation';
import { apiGetPage } from '../../request/api'
import { DeleteOutlined } from '@ant-design/icons';
import { Spin, message } from 'antd';
import NotHaveInfo from '../nothaveinfo';
import { useCustomData } from '../../pages/context/mineCustomDataProvider';

interface OrderCenterProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}
interface PageData {
    chooseCommodity: any;
    orderName: string;
    payType: string;
    orderPrice: string;
    orderStatus: string;
    created_at: string;
    createdTime: string;
    payAt: string;
    updated_at: string;
    launchCompany:string;
    id: string;
}

const OrderCenter: React.FC<OrderCenterProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [isHovering, setIsHovering] = useState(false);
    const [partList, setPartList] = useState<PageData[]>([]);
    const [hoverStates, setHoverStates] = useState(Array(partList.length).fill(false));
    const [commodityMap, setCommodityMap] = useState<Record<string, string>>({});
    const [loading, setLoading] = useState(false);
    const [companyMap, setCompanyMap] = useState<Record<string, string>>({});
    const languageCode = localStorage.getItem('siteLanguage') || 'zh';

    const { getValue } = useCustomData();
    const serviceName = getValue('serviceName');
    const price = getValue('price');
    const payAt = getValue('payAt');
    const operation = getValue('operation');
    const orderNumber = getValue('orderNumber');
    const state = getValue('state');
    const companyName1 = getValue('companyName');

    const statusColorMap: Record<string, string> = {
        '待确认': '#e60d0d',
        '待支付': '#e60d0d',
        '汇款确认': '#666666',
        '已支付': themeColor,
    };

    const statusTextMap: Record<string, Record<string, string>> = {
        待确认: {     
            zh: '待确认',
            en: 'Pending Confirmation',
        },
        待支付: {
            zh: '待支付',
            en: 'Pending Payment',
        },
        汇款确认: {
            zh: '汇款确认',
            en: 'Remittance Confirmation',
        },
        已支付: {
            zh: '已支付',
            en: 'Paid',
        },
    };

    const actionTextMap: Record<string, Record<string, string>> = {
        等待: {
            zh: '等待',
            en: 'Waiting',
        },
        支付: {
            zh: '支付',
            en: 'Pay',
        },
        查看: {
            zh: '查看',
            en: 'View',
        },
    };

    useEffect(() => {
        const userId = localStorage.getItem('userId');
        setLoading(true);

        Promise.all([
            apiGetPage({
                tid: 'F32F1F7909694585A88B730331221DB3',
                page: 1,
                size: 1000,
                search: 'informeUser:' + userId,
                sort: "orderStatus('待确认';'待支付';'汇款确认';'已支付')",
                languagecode: languageCode,
            }),
            apiGetPage({
                tid: '72D99CCB9A7E439184BF9EF7CABC49BA',
                page: 1,
                size: 100,
                search: '',
                languagecode: languageCode,
            }),
            apiGetPage({
                tid: 'E85B2C2CBF4C45FC89D7D540D35F780F',
                page: 1,
                size: 100,
                search: '',
                languagecode: languageCode,
            })
        ])
            .then(([orderRes, commodityRes, companyRes]) => {
                setPartList(orderRes.data.data.rows);

                // 商品映射
                const commodityMapTmp: Record<string, string> = {};
                commodityRes.data.data.rows.forEach((item: any) => {
                    commodityMapTmp[item.id] = item.commodityName;
                });
                setCommodityMap(commodityMapTmp);

                // 公司映射
                const companyMapTmp: Record<string, string> = {};
                (companyRes.data?.data?.rows || []).forEach((item: any) => {
                    companyMapTmp[item.id] = item.componyName; // 注意这里是 "componyName"
                });
                setCompanyMap(companyMapTmp);

                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setLoading(false);
            });
    }, []);

    const itemsPerPage = 5; // 每页显示的条目数
    const totalItems = partList.length;
    const [currentPage, setCurrentPage] = useState(1);


    const formatDate = (dateString: string) => {
        try {
            // 假设日期格式是 "YYYY-MM-DD HH:MM:SS"
            const date = new Date(dateString); // 尝试直接解析日期字符串
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从0开始
            const day = date.getDate().toString().padStart(2, '0');
            return `${year}.${month}.${day}`;
        } catch (error) {
            console.error('日期解析错误:', error);
            return '日期格式错误'; // 返回一个默认值或错误信息
        }
    };

    const handleMouseEnter = (index: number) => {
        const newHoverStates = [...hoverStates];
        newHoverStates[index] = true;
        setHoverStates(newHoverStates);
    };

    const handleMouseLeave = (index: number) => {
        const newHoverStates = [...hoverStates];
        newHoverStates[index] = false;
        setHoverStates(newHoverStates);
    };

    const gopay = (id: string) => {
        handleViewChange('payorder', id)
    }
    const godetail = (id: string) => {
        // handleViewChange('checkorder', 111)
        handleViewChange('checkorder', id)
    }
    return (
        <Spin spinning={loading} tip="">
            <div className="WorkOrder">
                <div className="work-title">
                    <span style={{ width: '200px' }}>{serviceName}</span>
                    <span style={{ width: '80px' }}>{price}</span>
                    <span style={{ width: '96px' }}>{payAt}</span>
                    <span style={{ width: '120px' }}>{companyName1}</span> {/* 新增列 */}
                    <span style={{ width: '67px' }}>{state}</span>
                    <span style={{ width: '76px' }}>{operation}</span>
                </div>
                {partList.slice((currentPage - 1) * 5, currentPage * itemsPerPage).map((item, index) => (
                    <div className='center-item' key={index}>
                        <div className="center-header">
                            <div className="order-createTime">{formatDate(item.createdTime)}</div>
                            <div className="order-number">{orderNumber}：{item.id}</div>
                            <div className="order-delete">
                                <DeleteOutlined
                                    style={{ color: hoverStates[index] ? themeColor : 'inherit' }}
                                    onMouseEnter={() => handleMouseEnter(index)}
                                    onMouseLeave={() => handleMouseLeave(index)}
                                />
                            </div>
                        </div>
                        <div className="center-bottom">
                            <div className='order-name'  style={{ width: '210px' }}>{commodityMap[item.chooseCommodity] || '未知商品'}</div>
                            <div className="order-price"  style={{ width: '80px' }}>{item.orderPrice}</div>
                            <div className="order-time">
                                {item.orderStatus === '已支付' ? formatDate(item.payAt) : '- -'}
                            </div>
                            {/* 新增公司名列 */}
                            <div className="order-company" style={{ width: '120px' }}>
                                {companyMap[item.launchCompany] || '未知公司'}
                            </div>
                            <div
                                className="order-takeTime"
                                style={{ color: statusColorMap[item.orderStatus] || '#666', width: '106px' }}
                            >
                                {statusTextMap[item.orderStatus]?.[languageCode] || item.orderStatus}
                            </div>
                            {item.orderStatus === '待确认' ? (
                                <div
                                    className="order-states"
                                    style={{ color: '#999', cursor: 'pointer', width: '56px' }}
                                    onClick={() =>
                                        message.info(
                                            languageCode === 'zh'
                                                ? '请等待工作人员确认'
                                                : 'Please wait for staff confirmation'
                                        )
                                    }
                                >
                                    {actionTextMap['等待'][languageCode]}
                                </div>
                            ) : item.orderStatus === '待支付' ? (
                                <div
                                    className="order-states"
                                    style={{ color: themeColor, width: '56px' }}
                                    onClick={() => gopay(item.id)}
                                >
                                    {actionTextMap['支付'][languageCode]}
                                </div>
                            ) : (
                                <div
                                    className="order-states"
                                    style={{ color: themeColor, width: '56px' }}
                                    onClick={() => godetail(item.id)}
                                >
                                    {actionTextMap['查看'][languageCode]}
                                </div>
                            )}
                        </div>
                    </div>
                ))}
                {!loading && totalItems == 0 && (
                    <NotHaveInfo />
                )}
                {totalItems > itemsPerPage && (
                    <Pagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                        themeColor={themeColor}
                    />
                )}
            </div>
        </Spin>
    );
};

export default OrderCenter;